// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/inventory/${file}.vue`);

export default [
    {
        path: "/stock-adjustment",
        name: "stock-adjustment-list",
        meta: { requiresAuth: true, applicationFeatureCode: "StockAdjustment" }, // StockAdjustment
        components: {
            content: lazyLoad('stock-adjustment-list'),
        },
    },
    {
        path: "/stock-adjustment/review/:id*",
        name: "stock-adjustment-review",
        meta: { requiresAuth: true, applicationFeatureCode: "StockAdjustment" },
        components: {
            content: lazyLoad('stock-adjustment'),
        },
    },
    {
        path: "/stock-adjustment/create",
        name: "stock-adjustment-create",
        meta: { requiresAuth: true, applicationFeatureCode: "StockAdjustment" },
        components: {
            content: lazyLoad('stock-adjustment'),
        },
    },
    {
        path: "/stock-adjustment-v2/review/:id*",
        name: "stock-adjustment-review-v2",
        meta: { requiresAuth: true, applicationFeatureCode: "StockAdjustment" },
        components: {
            content: lazyLoad('stock-adjustment-v2'),
        },
    },
    {
        path: "/stock-adjustment-v2/create*",
        name: "stock-adjustment-create-v2",
        meta: { requiresAuth: true, applicationFeatureCode: "StockAdjustment" },
        components: {
            content: lazyLoad('stock-adjustment-v2'),
        },
    },

    {
        path: "/stock-transfer",
        name: "stock-transfer-list",
        meta: { requiresAuth: true, applicationFeatureCode: "StockTransfer" },
        components: {
            content: lazyLoad('stock-transfer-review-list'),
        },
    },

    // StockTransfer V1
    {
        path: "/stock-transfer/create*",
        name: "stock-transfer-create",
        meta: { requiresAuth: true, applicationFeatureCode: "StockTransfer" },
        components: {
            content: lazyLoad('stock-transfer'),
        },
    },
    {
        path: "/stock-transfer/edit/:id*",
        name: "stock-transfer-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "StockTransfer" },
        components: {
            content: lazyLoad('stock-transfer'),
        },
    },
    {
        path: "/stock-transfer/review/:id*",
        name: "stock-transfer-review",
        meta: { requiresAuth: true, applicationFeatureCode: "StockTransfer" },
        components: {
            content: lazyLoad('stock-transfer'),
        },
    },

    // StockTransfer V2
    {
        path: "/stock-transfer-v2/create*",
        name: "stock-transfer-v2-create",
        meta: { requiresAuth: true, applicationFeatureCode: "StockTransfer" },
        components: {
            content: lazyLoad('stock-transfer-v2'),
        },
    },
    {
        path: "/stock-transfer-v2/edit/:id*",
        name: "stock-transfer-v2-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "StockTransfer" },
        components: {
            content: lazyLoad('stock-transfer-v2'),
        },
    },
    {
        path: "/stock-transfer-v2/review/:id*",
        name: "stock-transfer-v2-review",
        meta: { requiresAuth: true, applicationFeatureCode: "StockTransfer" },
        components: {
            content: lazyLoad('stock-transfer-v2'),
        },
    },

    {
        path: "/stocktake",
        name: "stocktake-list",
        meta: { requiresAuth: true, applicationFeatureCode: "StocktakeCount" },
        components: {
            content: lazyLoad('stock-take-list'),
        },
    },

    {
        path: "/stocktake/create",
        name: "stocktake-prepare",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "StocktakeManagement",
        },
        components: {
            content: lazyLoad('prepare-stocktake'),
        },
    },

    {
        path: "/stocktake-count/edit/:id*",
        name: "stocktake-count-edit",
        meta: { requiresAuth: true, applicationFeatureCode: "StocktakeCount" },
        components: {
            content: lazyLoad('stocktake-count'),
        },
    },
    {
        path: "/stocktake/review/:id",
        name: "stocktake-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "StocktakeManagement",
        },
        components: {
            content: lazyLoad('stocktake-review'),
        },
    },
    {
        path: "/intake-bin",
        name: "intake-bin",
        meta: { requiresAuth: true, applicationFeatureCode: "IntakeBins" },
        components: {
            content: lazyLoad('almondco-intake-bin-list'),
        },
    },

    

    

    {
        path: "/almondco-inshell-receive-manifest",
        name: "almondco-inshell-receive-manifest",
        meta: { requiresAuth: true },
        components: {
            content: lazyLoad('almondco-inshell-receive-manifest'),
        },
    },
]; 